import * as React from "react";

import { GalleryImg, GalleryItemInitials } from "./GalleryItemStyle";
import { DropImageHandler } from "common/components/portable-renderers";

interface Props {
    src?: string;
    onClick?: () => void;
    onDropImage?: DropImageHandler;
    fallback?: string;
}
interface State {}

export default class extends React.PureComponent<Props, State> {
    public state: State = {};

    public render(): React.ReactNode {
        const { src, onDropImage, onClick } = this.props;
        let fallback: React.ReactNode;
        if (this.props.fallback !== undefined) {
            fallback = <GalleryItemInitials>{this.props.fallback}</GalleryItemInitials>;
        }

        return <GalleryImg onDropImage={onDropImage} src={src} onClick={onClick} alternate={fallback} />;
    }
}
